// import anime from "animejs/lib/anime.es.js";
import Highway from "@dogstudio/highway";

import ProgressScroll from "../components/progressScroll";

var singleObject = {};

class Single extends Highway.Renderer {
  onEnter() {
    singleObject.progressScroll = new ProgressScroll().init();
  }

  onEnterCompleted() {}

  onLeave() {}

  onLeaveCompleted() {
    singleObject = {};
  }
}

export default Single;



// WEBPACK FOOTER //
// ./scripts/routes/single.js